import { Icon } from "@atoms/icon";
import { Typography } from "@atoms/typography";
import React, { FC, PropsWithChildren } from "react";
import styled from "styled-components";

export type DialogTitleProps = PropsWithChildren<{
  onClose?: () => void;
}>;

export const DialogTitle: FC<DialogTitleProps> = ({ children, onClose }) => {
  return (
    <Container>
      <Typography variant="title2">{children}</Typography>
      {onClose && (
        <button title="Close dialog" onClick={onClose}>
          <Icon name="close" />
        </button>
      )}
    </Container>
  );
};

const Container = styled.div`
  background-color: #fdbb30;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.0625em 0.3125em rgb(0 0 0 / 20%);

  h2 {
    color: #000;
    text-align: center;
    margin: 0;
    padding: 0;
    padding: 1em 0.5em;
    flex: 1;
    font-size: 1.2em;
    transition: transform 0.3s;
  }
  button {
    border: none;
    background: none;
    text-decoration: none;
    .fh-icon {
      color: #fff;
      font-size: 1.5em;
      padding: 0 0.5em;
      cursor: pointer;
    }
  }
`;
